/** The signed-in user as Laravel's `GET /auth/profile` returns it, cached in localStorage. */
interface IUserProfile {
  id: number;
  first_name: string;
  last_name: string;
  email?: string | null;
  phone?: string | null;
  birthdate?: string | null;
  image?: { id?: number; url: string } | null;
  /** Not sent by `/auth/profile`; older cached profiles carry it. */
  name?: string;
}

export interface IAuthData {
  id?: number;
  token?: string;
  firebase_token?: string;
  user_profile?: IUserProfile;
  user_phone?: string;
}

export const getAuth = (): IAuthData => {
  if (typeof window !== "undefined") {
    const token = localStorage.getItem("travela_auth_token") || undefined;
    const firebase_token =
      localStorage.getItem("travela_firebase_token") || undefined;
    const user_phone = localStorage.getItem("user_phone_number") || undefined;
    const userProfileString = localStorage.getItem("user_profile");
    const user_profile = userProfileString
      ? JSON.parse(userProfileString)
      : undefined;
    const id = user_profile?.id || undefined;

    return {
      id,
      token,
      firebase_token,
      user_profile,
      user_phone,
    };
  }
  return {};
};

export const clearAuth = (): void => {
  if (typeof window !== "undefined") {
    localStorage.clear();
    window.location.reload();
  }
};

const PROFILE_KEY = "user_profile";
const profileListeners = new Set<() => void>();

/** Subscribes to profile changes made through setProfile; returns the unsubscribe. */
export const subscribeProfile = (listener: () => void): (() => void) => {
  profileListeners.add(listener);
  return () => profileListeners.delete(listener);
};

/** The stored profile as raw JSON, a stable snapshot for useSyncExternalStore. */
export const getProfileSnapshot = (): string | null =>
  typeof window !== "undefined" ? localStorage.getItem(PROFILE_KEY) : null;

export const setProfile = (profile: unknown): void => {
  localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
  profileListeners.forEach((listener) => listener());
};

/** Stores the credentials a login or registration returns. */
export const setSession = ({
  id,
  access_token,
}: {
  id?: number | string;
  access_token?: string;
}): void => {
  if (id) localStorage.setItem("travela_auth_id", String(id));
  if (access_token)
    localStorage.setItem("travela_auth_token", `Bearer ${access_token}`);
};
